exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".btn-back{background-color:#0091ff}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/tradezone/FormSubTradezone.vue"],"names":[],"mappings":"AACA,UACI,wBAA0B,CAC7B","file":"FormSubTradezone.vue","sourcesContent":["\n.btn-back {\n    background-color: #0091ff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e54dc77","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/tradezone/FormSubTradezone.vue
// module id = 1902
// module chunks = 0